import { Box, Tag, Text } from '@bechtel/gds';
import { getSplittedToolCatalogName } from '@bechtel/ht-clients-common';
import { Uom } from '@bechtel/ht-types';
import { FC, useMemo } from 'react';
import { ErrorBoundary } from '~/components';
import { ImageFallback } from '~/components/image-fallback';
import { ToolCatalogTitleStyled } from './styled';

interface CatalogItemProps {
  catalogName: string;
  bscnPartNumber: string;
  toolCatalogImageUrl?: string | null;
  toolCatalogThumbnailImageUrl?: string | null;
  fallbackName?: string;
  inventoryType?: string;
  uom?: Uom | null;
}

export const CatalogItem: FC<CatalogItemProps> = ({
  catalogName,
  uom,
  toolCatalogImageUrl,
  toolCatalogThumbnailImageUrl,
  fallbackName,
  bscnPartNumber,
  inventoryType,
}) => {
  const isSerialized = useMemo(() => {
    return ['Individual', 'Equipment'].includes(inventoryType ?? '') ? true : false;
  }, [inventoryType]);

  const toolCatalogDetails = useMemo(() => {
    return getSplittedToolCatalogName(catalogName || '');
  }, [catalogName]);
  return (
    <ErrorBoundary>
      <Box alignItems={{ sm: 'center' }}>
        <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} mr={{ sm: '500' }} pt={{ sm: '200' }}>
          <ImageFallback
            imageUrl={toolCatalogImageUrl || ''}
            thumbnailImageUrl={toolCatalogThumbnailImageUrl || ''}
            fallbackName={fallbackName || ''}
          />
        </Box>
        <Box flexDirection={{ sm: 'column' }}>
          <Box>
            <Tag bgColor={isSerialized ? 'orange.200' : 'neutral.200'}>
              <Text size="300" family="openSansCondensed">
                {bscnPartNumber}
              </Text>
            </Tag>
          </Box>
          <Box flexDirection={{ sm: 'column' }} gap={{ sm: '200' }} css={{ maxWidth: '280px' }}>
            <ToolCatalogTitleStyled>{toolCatalogDetails.title}</ToolCatalogTitleStyled>
            {(toolCatalogDetails.subTitle || uom) && (
              <Text color="blue.800" weight="500" size="300" family="openSans">
                {uom?.abbreviation
                  ? `${toolCatalogDetails.subTitle} (${uom?.abbreviation})`
                  : toolCatalogDetails.subTitle}
              </Text>
            )}
          </Box>
        </Box>
      </Box>
    </ErrorBoundary>
  );
};
